// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".srh__search-box{-webkit-clip-path:inset(0 -10px -10px -10px);clip-path:inset(0 -10px -10px -10px);height:100%}.hide-search-box .srh__search-box{display:none!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
